<template>
  <div>
    <v-list>
      <template v-for="(item, i) in items" :key="item.bookableId">
        <template v-if="itemObject(item.bookableId)">
          <v-list-item class="py-3">
            <template #default>
              <div class="d-flex justify-space-between" style="width: 270px">
                <div class="d-flex flex-column">
                  <span> {{ itemObject(item.bookableId).title }}</span>
                  <p style="opacity: 0.8;">{{ itemObject(item.bookableId).type }}</p>
                </div>
                <v-checkbox
                  v-model="item.mandatory"
                  hide-details
                  density="compact"
                  class="align-right"
                  style="opacity: 0.8;"
                  label="verpflichtend"
                />
              </div>
            </template>
            <template #append>
              <div class="d-flex align-center">
                <v-btn
                  icon
                  variant="text"
                  size="small"
                  v-if="i > 0"
                  @click="moveUp(i)"
                >
                  <v-icon color="grey-lighten-1">mdi-chevron-up</v-icon>
                </v-btn>

                <v-btn
                  icon
                  variant="text"
                  size="small"
                  v-if="i < items.length - 1"
                  @click="moveDown(i)"
                >
                  <v-icon color="grey-lighten-1">mdi-chevron-down</v-icon>
                </v-btn>

                <v-btn icon variant="text" size="small" @click="remove(i)">
                  <v-icon color="grey-lighten-1">mdi-close</v-icon>
                </v-btn>
              </div>
            </template>
          </v-list-item>

          <v-divider v-if="i < items.length - 1" />
        </template>
      </template>
    </v-list>

    <div
      class="font-italic text-center text-grey my-5"
      v-if="!items || items.length === 0"
    >
      Es sind keine Einträge vorhanden.
    </div>

    <v-autocomplete
      hide-details
      placeholder="Ein weiteres Element Hinzufügen"
      v-model="addItemValue"
      :items="unselectedItems"
      item-value="id"
      item-title="title"
      variant="underlined"
    >
      <template #append>
        <v-btn size="small" color="primary" @click="add">
          <v-icon start> mdi-plus</v-icon>
          Hinzufügen
        </v-btn>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  name: "BookableCheckoutBookables",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    availableItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      addItemValue: null,
    };
  },

  methods: {
    moveUp(index) {
      if (index > 0) {
        const item = this.items[index];
        this.items.splice(index, 1);
        this.items.splice(index - 1, 0, item);
      }
    },
    moveDown(index) {
      if (index < this.items.length - 1) {
        const item = this.items[index];
        this.items.splice(index, 1);
        this.items.splice(index + 1, 0, item);
      }
    },
    remove(index) {
      this.items.splice(index, 1);
    },
    add() {
      if (this.addItemValue != null) {
        this.items.push({ bookableId: this.addItemValue, mandatory: false });
        this.addItemValue = null;
      }
    },
    itemObject(id) {
      return this.availableItems.find((item) => item.id === id);
    },
  },

  computed: {
    unselectedItems() {
      return this.availableItems.filter(
        (item) => !this.items.includes(item.id)
      );
    },
  },
};
</script>

<style scoped></style>
